import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TutorService } from "src/app/_services/tutor.service";
import { DeleteTutor, DeleteTutorError, DeleteTutorSuccess } from "./tutor-delete.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { of } from "rxjs";

@Injectable()
export class TutorDeleteEffects {
  constructor(
    private action$: Actions,
    private tutorService: TutorService,
  ) {}

  public deleteListOfTutorEffects$ = createEffect(() => 
    this.action$.pipe(
      ofType(DeleteTutor),
      switchMap((payload) => 
        this.tutorService.deleteListOfTutor$(payload.tutorIds).pipe(
          map((result: boolean) => {
            return DeleteTutorSuccess({result: result});
          }),
          catchError((error) => {
            return of(DeleteTutorError({error: error}));
          })
        )
      )
    )
  );
}